import RecentVisitedProfile from "./RecentVisitedProfile";

export default RecentVisitedProfile;
